export const Hourglass = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 29H26" stroke="currentColor" stroke-width="2"/>
<path d="M6 3H26" stroke="currentColor" stroke-width="2"/>
<path d="M10 3V11.6667C10 11.883 10.0702 12.0936 10.2 12.2667L13 16L10.2 19.7333C10.0702 19.9064 10 20.117 10 20.3333V29" stroke="currentColor" stroke-width="2"/>
<path d="M22 3V11.6667C22 11.883 21.9298 12.0936 21.8 12.2667L19 16L21.8 19.7333C21.9298 19.9064 22 20.117 22 20.3333V29" stroke="currentColor" stroke-width="2"/>
<path d="M10.5 12H21.5" stroke="currentColor" stroke-width="2"/>
<rect x="15.5" y="19.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
<rect x="15.5" y="23.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
</svg>`;
